import styled from 'styled-components';
import { mq, getTextType, getGridSpan } from '../../../stylesheets/tools';

export const StyledImage = styled.img`
  display: inline-block;
`;

export const StyledImageSkeleton = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
  padding-bottom: calc(9 / 16 * 100% - 10px);
  border: 3px solid black;
  background: #fff;

  ${mq('m')} {
    border: 5px solid black;
  }

  span {
    position: absolute;
    width: 100%;
    text-transform: uppercase;
    bottom: 0;
    left: 0;
    padding: 30px 30px 40px;
    ${getTextType('subline')}

    ${mq('m')} {
      width: ${getGridSpan(8)};
      ${getTextType('primary')}
    }

    &:before {
      position: absolute;
      content: '';
      width: 50px;
      height: 3px;
      top: 0px;
      left: -25px;
      background: #000;

      ${mq('m')} {
        height: 5px;
      }
    }
  }
`;
